import React from "react";
import { useCallbackRef } from "../../hooks/useCallbackRef";
import { isDefined } from "../Generic/IsDefined";

interface Props {
  shouldOverlay: boolean | { from: number };
  headerRef: React.RefObject<HTMLDivElement>;
  scrollRef: React.RefObject<HTMLDivElement>;
}

const useOverlayScaffold = (props: Props) => {
  const shouldOverlayRef = useCallbackRef(() => props.shouldOverlay);

  React.useEffect(() => {
    const { current: scrollElem } = props.scrollRef;
    const { current: headerElem } = props.headerRef;
    const shouldOverlay = shouldOverlayRef();

    if (!isDefined(scrollElem) || !isDefined(headerElem)) {
      return;
    }

    const event = (e: Event) => {
      const offset = typeof shouldOverlay === "object" ? shouldOverlay.from : 100;
      const opacity = Math.min(((e.target as any).scrollTop - offset) / offset, 1);
      headerElem.style.setProperty("--background-opacity", `${opacity}`);
    };

    if (shouldOverlay !== false) {
      headerElem.style.setProperty("--background-opacity", "0");
      scrollElem.addEventListener("scroll", event);
    }

    return () => scrollElem.removeEventListener("scroll", event);
  }, [props.headerRef, props.scrollRef, shouldOverlayRef]);
};

export default useOverlayScaffold;
